<template>
  <div class="modal">
    <!-- Backdrop -->
    <div
      class="modal__backdrop"
      @click="closeModal"
    ></div>

    <!-- Modals Container -->
    <div class="modal__container">
      <div class="modal__content">
        <slot name="heading" />
        <slot name="content" />
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const emit = defineEmits<{
  close: []
}>()

const closeModal = (): void => {
  emit('close')
}
</script>
